// Copyright (c) StrangeBee 2023

import LocalDrawer from './LocalDrawer';
import OauthDrawer from './OauthDrawer';
import DirectoryDrawer from './DirectoryDrawer';
import SAMLDrawer from './SAMLDrawer';

export const libConfigDrawer: Record<string, any> = {
    local: LocalDrawer,
    oauth2: OauthDrawer,
    directory: DirectoryDrawer,
    sso: SAMLDrawer,
};
